export const SUKIYA_TOPPING_TYPE = {
  Set: 'Set',
  Topping: 'Topping',
  Drink: 'Drink',
  Size: 'Size',
}
